
/**
 * API utilities for amenities
 */

import { handleApiError } from './vehicleAPI';

export interface Amenity {
  id: number;
  name: string;
  description?: string;
}

export const fetchAmenities = async (): Promise<Amenity[]> => {
  try {
    const token = localStorage.getItem("authToken");
    if (!token) {
      console.error("No auth token found");
      return [];
    }
    
    console.log("Fetching amenities from API");
    
    const response = await fetch("https://api.discoveryconciergeservices.com/api/v1/amenities/", {
      headers: {
        "Authorization": `Token ${token}`,
        "Accept": "application/json"
      }
    });
    
    if (!response.ok) {
      const errorMessage = await handleApiError(response);
      throw new Error(errorMessage);
    }
    
    const data = await response.json();
    console.log("Amenities fetched successfully:", data);
    
    if (Array.isArray(data)) {
      return data;
    } else if (data && data.results && Array.isArray(data.results)) {
      return data.results;
    }
    
    return [];
  } catch (error) {
    console.error("Error fetching amenities:", error);
    return [];
  }
};
